import React from 'react';
import "../comp_styles/hero.css";

class MainSection extends React.Component {

    render() {
        return (
            <div>
                <div className="hero-section">
                    <div className="hero-section-text">
                        <div className="company2">
                            <p>mobi</p>
                        </div>
                        <div className="herotxt">
                            <p>Your all in one platform to keep track of what matters the most - your next career.</p>
                        </div>
                    </div>
                </div>
            </div>
        )


    }
}

export default MainSection


// WEBPACK FOOTER //
// ./src/components/hero.js